module.exports = __webpack_public_path__ + "img/con-en.9ec92f6b.png";